import React from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { TeamsIcon } from '@mobi/sports-offering/Components/Common/TeamsIcon'
import { LegStatusIcon } from '../LegStatusIcon'
import { BetOfferType } from '@mobi/api-types/kambi/constants'

export const LegsProgressStatus: React.FC<{
  outcomes: KambiHistoryCoupon['outcomes']
  betOffers: KambiHistoryCoupon['betOffers']
  events: KambiHistoryCoupon['events']
}> = ({ outcomes, betOffers, events }) => {
  return (
    <div style={{ paddingTop: '0.2rem' }}>
      <Flex gap='0.4rem' alignItems='center' alignContent='flex-start' flexWrap='wrap'>
        {outcomes.map(outcome => {
          if (outcome.status === 'WON' || outcome.status === 'LOST') {
            return <LegStatusIcon key={outcome.outcomeId} status={outcome.status} />
          }

          const event = events.find(e => e.eventId === outcome.eventId)
          const betOfferTypeId =
            betOffers.find(b => b.betOfferId === outcome.betOfferId)?.boTypeId ??
            BetOfferType.Handicap
          const sportName = event?.sport

          return (
            <TeamsIcon
              key={outcome.outcomeId}
              outcomeId={outcome.outcomeId}
              betOfferType={betOfferTypeId}
              betOfferId={outcome.betOfferId}
              size='1.6rem'
              participantId={outcome.participantId}
              sportName={sportName}
            />
          )
        })}
      </Flex>
    </div>
  )
}
